import {
  getUserServiceFlag,
  OKTAUserSeviceFlagEnum,
} from "@src/app/hooks/useUserInfo.ts";

export default function hasServiceFlag(
  serviceFlagToCheck: OKTAUserSeviceFlagEnum,
) {
  const serviceFlags = getUserServiceFlag() || "";
  if (!serviceFlags) return false;
  const services = serviceFlags.split("|");
  return services.includes(serviceFlagToCheck);
}
